module.exports = __webpack_public_path__ + "static/media/wheel.1011c7c9.png";